import React, { useEffect, useState } from "react";
import '../css/customModalDeleteWallet.css'
import Modal from 'react-bootstrap/Modal';
import CustomButton from "./CustomButton";
import { IoIosArrowDown } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { useMobileMediaQuery, useTabletMediaQuery } from "../utils";
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId } from '../features/onboardingData/onboardingUserData';
import { AiOutlineStop } from "react-icons/ai";
import { toast } from "react-toastify";
import { errorHandling } from "../utils";
import { removeSecureData } from "../utils/secureStorage";

const CustomModalDeleteWallet = (props) => {
    const {
        title = '',
    } = props;
    
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [openSecondModal, setOpenSecondModal] = useState(false);    
    const [selectOptions, setSelectOptions] = useState('');
    const [selectMyReason, setSelectMyReason] = useState('');
    const [inputFocus, setInputFocus] = useState(false);

    const fetchCSRFToken = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
            credentials: "include",
            mode: 'cors'
          });
          const data = await response.json();
          const csrfToken = data.csrfToken;
    
          return csrfToken;
        } catch (error) {
          errorHandling('CSRF');
        }
    };

    const postApagaCarteira = async () => {
        try {
            const csrfToken = await fetchCSRFToken();
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/apagaCarteira/fetchApagaCarteira`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'PT-PT',
                'CookieId': `${isCookieId}`,
                'SessionId': `${isSessionId}`,
                "xsrf-token": csrfToken,
            },
            credentials: "include",
            mode: "cors",
            body: JSON.stringify({ motivo: selectOptions === 'Outro motivo' ? selectMyReason : selectOptions }),
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.erroMsg === 'Success') {
                handleNav();
            } else {
                toast.error("Lamentamos, mas neste momento, não conseguimos apagar a sua Carteira Virtual. Por favor, tente mais tarde.", {
                    icon: <AiOutlineStop/>
                });
                handleError();
            }
        } catch (error) {
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    const deleteWallet = () => {
        postApagaCarteira();
        removeSecureData('isSessionId');
        removeSecureData('isCookieId');
        removeSecureData('isHasAccess');
        removeSecureData('isAccessToken');
        removeSecureData('isAssociatedInsuraceList');
        removeSecureData('isNAssocia');
        removeSecureData('isRedirectUrl');
        removeSecureData('isTokenExpiresOn');
    }

    const handleFocus = () => {
        setInputFocus(true);
    }

    const handleBlur = () => {
        setInputFocus(!inputFocus);
    }

    const handleClose  = () => {
        setSelectOptions('');
        setSelectMyReason('');
        setOpenSecondModal(false);
    };

    const handleShow = () => {
        setOpenSecondModal(!openSecondModal);
        props.onHide();
    };

    const handleMainClose  = () => {
        setSelectOptions('');
        setSelectMyReason('');
        props.onHide();
    };

    const handleInputReason = (event) => {
        const newValue = event.target.value;
        setSelectOptions(newValue);
    };

    const handleInputTextArea = (event) => {
        const newValue = event.target.value;
        setSelectMyReason(newValue);
    };

    const handleSeacrhReason = (item) => {
        setSelectOptions(item.options)
        setInputFocus(false);
    }

    const selectOptionsList = [
        { options: 'Estou insatisfeito com a funcionalidade ou desempenho' },
        { options: 'Preocupações com segurança ou privacidade' },
        { options: 'Apenas estava a experimentar, não tinha intenção de usar a longo prazo' },
        { options: 'Catálogo de parceiros não me agradou/não uso' },
        { options: 'Outro motivo' },  
    ]

    const handleNav = () => {
        setOpenSecondModal(false);
        setSelectOptions('');
        setSelectMyReason('');
        window.location.href = 'https://saude360.medis.pt';
    };

    const handleError = () => {
        setOpenSecondModal(false);
        setSelectOptions('');
        setSelectMyReason('');
        props.onHide();
    };

    return (
        <>
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modalMainContainerModalDeleteWallet"
            fullscreen={ isTablet ? false : ( isMobile ? false : true) }
        >
            <div className={ isTablet ? 'mainOptionsColumnViewContainerModalDeleteWallet' : ( isMobile ? 'mainOptionsColumnViewContainerModalDeleteWalletTablet' : 'mainOptionsColumnViewContainerModalDeleteWalletMobile' )}>
                <div className={ isTablet ? 'adicioanTopWitheViewContainerModalDeleteWallet' : ( isMobile ? 'adicioanTopWitheViewContainerModalDeleteWallet' : 'adicioanTopWitheViewContainerModalDeleteWalletMobile')}>
                    <div className='txtFirstOptionsTitleViewRowModalDeleteWallet'>
                        <div className='txtFirstCloseTitleModalDeleteWallet'>Sair</div>
                        <button className='btnViewFirstCloseTitleModalDeleteWallet' onClick={handleMainClose}><IoMdClose className="closeIconModalDeleteWallet"/></button>
                    </div>
                    <div className='txtFirstOptionsTitleViewModalDeleteWallet'>
                        <div className='txtViewContentContainerModalDeleteWallet'>
                            <div className='txtFirstOptionsTitleModalDeleteWallet'>Estamos tristes por vê-lo partir... 🍂</div>
                        </div>
                        <div className='txtViewContentContainerModalDeleteWallet'>
                            <div className='txtContentModalDeleteWallet'>
                                Antes de dizermos adeus à sua carteira virtual, poderia partilhar connosco o que o levou a esta decisão? O seu feedback é incrivelmente valioso e ajudar-nos-á a melhorar a experiência para todos os nossos utilizadores.
                            </div>
                        </div>

                        <div className='textWrapperModalDeleteWallet'>
                            { selectOptions.length > 0 &&
                            <label className='labelInputModalDeleteWallet'>Indique-nos qual o motivo</label>
                            }
                            <input 
                                className={ selectOptions.length > 0 ? 'inputTextModalDeleteWallet focused' : 'inputTextModalDeleteWallet'}
                                type="text" 
                                placeholder='Indique-nos qual o motivo'
                                value={selectOptions}
                                onChange={handleInputReason}
                                onFocus={handleFocus}
                                //maxLength={15}
                            />
                            <div className='findIconViewModalDeleteWallet' onClick={handleBlur}><IoIosArrowDown className='findIconModalDeleteWallet' /></div>
                        </div>
                        { inputFocus  && (
                            <div className='textWrapperCollumnModalDeleteWallet' style={{marginTop: '-16px'}}>
                                {selectOptionsList.map((item, index)=>(
                                    <div key={index} className="searchPosCodListViewModalDeleteWallet">
                                        <button  className='txtSelectPlaceBtnModalDeleteWallet' onClick={() => handleSeacrhReason(item)}>{item.options}</button>
                                    </div>
                                ))}
                            </div>
                        )}
                        { selectOptions === "Outro motivo" &&
                            <div className='textareaMainViewContentContainerModalDeleteWallet'>
                                <div className='textareaViewContentContainerModalDeleteWallet'>
                                    <textarea 
                                        className='inputTextModalDeleteWallet'
                                        placeholder='Indique-nos qual o motivo (opcional)'
                                        value={selectMyReason}
                                        onChange={handleInputTextArea}
                                        maxLength={1000}
                                    />
                                </div>
                                <div className='txtInfoAreaContainerModalDeleteWallet'>
                                    <span className='txtInfoAreaContainerModalDeleteWallet'>{`${selectMyReason.length}/1000 caracteres`} </span>
                                    <span className='txtSecondInfoAreaContainerModalDeleteWallet'>{`(campo opcional)`}</span>
                                </div>
                            </div>
                        }
                                                
                        <div className='btnMainViewContainerModalDeleteWallet'>
                            <CustomButton 
                                text={'Cancelar'} 
                                onPress={handleMainClose}
                                textColor={'#00214D'}
                                borderColor={'#00214D'}
                                hasShadow={false}
                                isSmall
                            />
                            <CustomButton 
                                text={'Submeter'} 
                                onPress={handleShow}
                                textColor={'#00214D'}
                                color={'#15D4B6'}
                                hasArrow
                                iconColor={'#00214D'}
                                enabled={selectOptions.length > 0}
                                isSmall
                            />
                        </div>            
                    </div>  
                </div>                      
            </div>            
        </Modal>

        <Modal 
            show={openSecondModal} 
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modalMainContainerModalDeleteWallet"
            fullscreen={ isTablet ? false : ( isMobile ? false : true) }
        >
            <div className='mainOptionsColumnViewContainerModalDeleteWallet'>
                <div className='txtFirstOptionsTitleViewRowModalDeleteWallet'>
                    <div className='txtFirstCloseTitleModalDeleteWallet'>Sair</div>
                    <button className='btnViewFirstCloseTitleModalDeleteWallet' onClick={handleClose}><IoMdClose className="closeIconModalDeleteWallet"/></button>
                </div>
                <div className='txtFirstOptionsTitleViewModalDeleteWallet'>
                    <div className='txtViewContentContainerModalDeleteWallet'>
                        <div className='txtFirstOptionsTitleModalDeleteWallet'>Apagar carteira</div>
                    </div>
                    <div className='txtViewContentContainerModalDeleteWallet'>
                        <div className='txtSemiBoldContentModalDeleteWallet'>
                            Se apagar a Carteira Virtual perderá todo o seu saldo e histórico.
                        </div>
                        <div className='txtContentModalDeleteWallet'>
                            Esta ação é irreversível. 
                        </div>
                    </div>
                    <div className='txtViewContentContainerModalDeleteWallet'>
                        <div className='txtContentModalDeleteWallet'>
                            No entanto, a qualquer momento pode voltar a ativar a sua Carteira Virtual, a partir da página inicial da Médis.
                        </div>
                    </div>
                    <div className='btnMainViewContainerModalDeleteWallet'>
                        { isTablet ?
                            <CustomButton 
                                text={'Cancelar'} 
                                onPress={handleClose}
                                textColor={'#00214D'}
                                borderColor={'#00214D'}
                                hasShadow={false}
                                isSmall
                            />
                            : ( isMobile ? 
                                <CustomButton 
                                    text={'Cancelar'} 
                                    onPress={handleClose}
                                    textColor={'#00214D'}
                                    borderColor={'#00214D'}
                                    hasShadow={false}
                                    isSmall
                                />
                                : null
                            )
                        }
                        <CustomButton 
                            text={'Apagar Carteira Virtual'} 
                            onPress={deleteWallet}
                            textColor={'#FFFFFF'}
                            color={'#E00060'}
                            hasArrow
                            iconColor={'#FFFFFF'}
                        />
                    </div>
                </div>
            </div>
        </Modal>       
       </> 
    );
};

export default CustomModalDeleteWallet;